import { render, staticRenderFns } from "./grid-component.vue?vue&type=template&id=506b729d&scoped=true&"
import script from "./grid-component.vue?vue&type=script&lang=js&"
export * from "./grid-component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506b729d",
  null
  
)

export default component.exports